<footer id="footer-contact" class="main-footer">
  <div class="footer-links-grid">
    <div class="footer-column">
      <h4>EXPLORE</h4>
      <a routerLink="/" (click)="handleLinkClick('/')">HOME</a>
      <a routerLink="/programs" (click)="handleLinkClick('/programs')">PROGRAMS</a>
      <a routerLink="/gallery" (click)="handleLinkClick('/gallery')">GALLERY</a>
      <a routerLink="/store" (click)="handleLinkClick('/store')">STORE</a>
      <a routerLink="/booking" (click)="handleLinkClick('/booking')">BOOK SLOTS</a>
    </div>
    <div class="footer-column">
      <h4>COMPANY</h4>
      <a routerLink="/about" (click)="handleLinkClick('/about')">OUR STORY</a>
      <a routerLink="/instructors-founders" (click)="handleLinkClick('/instructors-founders')">INSTRUCTORS</a>
      <a routerLink="/contact" (click)="handleLinkClick('/contact')">CONTACT</a>
      <a routerLink="/register" (click)="handleLinkClick('/register')">REGISTER</a>
    </div>
    <div class="footer-column">
      <h4>LEGAL</h4>
      <a routerLink="/privacy-policy" (click)="handleLinkClick('/privacy-policy')">PRIVACY POLICY</a>
      <a routerLink="/terms-and-conditions" (click)="handleLinkClick('/terms-and-conditions')">TERMS OF SERVICE</a>
    </div>
  </div>

  <div class="footer-social">
    <a href="https://www.instagram.com/thefloortheory_?igsh=emN5OXNkdTk0ZTRr&utm_source=qr" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><lucide-icon [name]="InstagramIcon" size="20" ></lucide-icon></a>
    <a href="https://www.facebook.com/share/1dCVxYTQNm/?mibextid=wwXIfr" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><lucide-icon [name]="FacebookIcon" size="20"></lucide-icon></a>
    <a href="https://www.youtube.com/@TheFloorTheory" aria-label="YouTube" target="_blank" rel="noopener noreferrer"><lucide-icon [name]="YoutubeIcon" size="20"></lucide-icon></a>
    <a href="https://wa.me/917358790656" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer"><lucide-icon [name]="WhatsAppIcon" size="20"></lucide-icon></a>
    <!-- <a href="#" aria-label="Twitter"><lucide-icon [name]="TwitterIcon" size="20"></lucide-icon></a> -->
  </div>

  <div class="footer-bottom">
    <p>© {{ currentYear }} THE FLOOR THEORY. ALL RIGHTS RESERVED.</p>
  </div>
</footer>
